import React from 'react'
import { withTranslation } from 'react-i18next'
import BackAnchor from 'shared/components/BackAnchor'

const ScreeningQuestionYesView = ({ t, i18n }) => {
  const payADebtURL =
    i18n.language === 'en'
      ? 'https://beta.novascotia.ca/make-payment-your-collection-services-account'
      : 'https://www.novascotia.ca/fr/faire-un-paiement-votre-compte-des-services-de-recouvrement'

  return (
    <div className="container">
      <BackAnchor backPath="routes.screening_question" />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <p>
            {t('screening_question_yes.if_you_received_letter')}
            <a href={payADebtURL} target="_blank" rel="noopener noreferrer">
              {t('screening_question_yes.pay_a_debt_link')}
            </a>
            {t('screening_question_yes.service_instead')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(ScreeningQuestionYesView)
